<template>
  <div>
    <a-card size="small" :bordered="true" style="border: 1px solid #ccc; padding: 10px; border-radius: 4px;">
      <template slot="title">
        <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap">
          <!-- 质量成员部分 -->
          <span style="margin-right: 8px">质量成员:</span>
          <a-checkable-tag
            :checked="selectedQaMembers.length === 0"
            @change="selectedQaMembers = []"
          >全部</a-checkable-tag>
          <a-checkable-tag
            v-for="qaMember in qaMembers"
            :key="qaMember.id"
            :checked="selectedQaMembers.includes(qaMember.id)"
            @change="checked => handleChange(qaMember.id, checked)"
          >{{ qaMember.name }}</a-checkable-tag>
        </div>
        <!-- 新增周期按钮组 -->
        <div style="margin-top: 8px">
          <span style="margin-right: 8px">周期:</span>
          <a-button-group>
            <a-button
              v-for="unit in periodOptions"
              :key="unit.value"
              :type="activePeriod === unit.value ? 'primary' : 'default'"
              @click="handlePeriodChange(unit.value)"
            >{{ unit.label }}</a-button>
          </a-button-group>
        </div>
      </template>
    </a-card>
  </div>
</template>

<script>
import { userRoleList } from '@/api/system/auth';
import { periodOptions } from '@/utils/dictionary'; // 确保引入周期选项

export default {
  name: 'QaMemberFilter',
  props: {
    value: { // 保持 v-model 兼容性
      type: Object,
      default: () => ({
        qaMembers: [],
        period: 'month' // 新增 period 字段
      })
    }
  },
  data() {
    return {
      qaMembers: [],
      periodOptions
    };
  },
  computed: {
    selectedQaMembers: {
      get() {
        return this.value.qaMembers;
      },
      set(val) {
        this.$emit('input', { ...this.value, qaMembers: val });
      }
    },
    activePeriod: {
      get() {
        return this.value.period;
      },
      set(val) {
        this.$emit('input', { ...this.value, period: val });
      }
    }
  },
  created() {
    this.getQaMemberList();
  },
  methods: {
    handleChange(qaMemberId, checked) {
      this.selectedQaMembers = checked
        ? [...this.selectedQaMembers, qaMemberId]
        : this.selectedQaMembers.filter(id => id !== qaMemberId);
    },
    handlePeriodChange(period) {
      this.activePeriod = period;
    },
    getQaMemberList() {
      userRoleList({ role_id: 173 }).then(res => {
        this.qaMembers = res.data.items.filter(item => item.status === 0);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
